import { produce, Draft } from 'immer'
//import {Confirm} from "semantic-ui-react";

enum redirectType {
  Login = 'login',
  Confirm = 'confirm',
}

type State = {
  authenticationStatus: number;
  hasMdp: boolean,
  hasModule: boolean,
  isBookerHasMailOTA: boolean,
  modalRedirect: boolean,
  modalRedirectType: redirectType;
}

const authentication = {
  state: {
    authenticationStatus: null,
    hasMdp: false,
    hasModule: true,
    isBookerHasMailOTA: false,
    modalRedirect: false,
    modalRedirectType: 'login'
  } as State,
  reducers: {
    setAuthenticationInfos: produce((draft: Draft<State>, payload: Partial<State>) => {
      // draft.authenticationStatus = payload.authenticationStatus;
      // draft.hasMdp = payload.hasMdp;
      // draft.hasModule = payload.hasModule;
      Object.assign(draft, payload)
    }),
    handleRedirectType: produce((draft: Draft<State>, callback?: Function, event?: Event): void => {
      if( draft.authenticationStatus == 2 ) {

        // lien de redirection
        if (draft.hasMdp === false) {
          // creation mdp
          draft.modalRedirectType = redirectType.Confirm
        }
        else if(draft.hasMdp === true ){
          // page connexion
          draft.modalRedirectType = redirectType.Login
        }

        draft.modalRedirect = true;

        // bloque redirection automatique
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
      }
      else {
        if (callback) callback();
      }
    }),
    handleRedirect: produce((draft: Draft<State>, isOpen: boolean) => {
      draft.modalRedirect = isOpen;
    })
  },
  effects: dispatch => ({
    async handleRedirectTypeAsync(callback: Function, rootState) {
      dispatch.authentication.handleRedirectType(
        null,
      );
      
      if (rootState.authentication.authenticationStatus != 2) {
        callback();
      }
    }
  })
}



export default authentication